import script from "./annualLeavingType.vue?vue&type=script&setup=true&lang=js"
export * from "./annualLeavingType.vue?vue&type=script&setup=true&lang=js"

import "./annualLeavingType.vue?vue&type=style&index=0&id=161b52f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161b52f8"]])

export default __exports__